import MyIntegerInput from './integer-input.vue';

const IntegerInput = {
  install: (Vue: any) => {
    Vue.component('IntegerInput', MyIntegerInput);
  },
};

export default IntegerInput;
